import React, { useContext, useState } from 'react'
import { MeContext } from 'contexts/me'
import { redirectWhatsApp } from 'utils/redirectWhatsApp'
import PrimaryButton from 'components/primaryButton'
import { useNavigate } from 'react-router-dom'
import TextButton from 'components/textButton'
import { ContactAdvisorIcon, NotPhysicalCardIcon } from 'assets/icons'
import { ZENDESK_URL } from 'config'
import UnavailableCardModal from 'components/UnavailableCardModal'
import { useLimitPhysicalCardStore } from 'store'
import MinBalanceModal from './MinBalanceModal'

// Auxiliary component for dynamic use
export const AuxModals = ({ type }: { type: keyof typeof MODAL_CONTENT }) => {
  const navigate = useNavigate()
  const [unavailableModal, setUnavailableModal] = useState(false)
  // modal for when user doesn't reach the required minimum balance
  const [balanceModalIsOpen, setBalanceModalIsOpen] = useState<boolean>(false)
  const { me } = useContext(MeContext)
  const { canRequestCard } = useLimitPhysicalCardStore()

  const MODAL_CONTENT = {
    CONTACT_ADVISOR: {
      buttonText: 'Contactar con un asesor',
      icon: <ContactAdvisorIcon />,
      action: () => window.open(`${ZENDESK_URL}/requests/new`, '_blank'),
      content:
        'Para continuar te solicitamos que te comuniques con un asesor para seguir con el pedido de tu tarjeta',
      title: 'Estas más cerca de tener tu tarjeta 🙌'
    },
    PHYSICAL_CARD_NOT_DELIVERED: {
      buttonText: 'Solicitar nueva tarjeta',
      icon: <NotPhysicalCardIcon />,
      title: 'No logramos entregarte tu tarjeta Wayni',
      action: () => {
        // cuando no hay tarjetas disponibles:
        // setUnavailableModal(true)
        if (canRequestCard) {
          navigate('/direccion-tarjeta-fisica')
        } else {
          setBalanceModalIsOpen(true)
        }
      },
      content: (
        <p>
          Podés volver a solicitar tu tarjeta física <br /> sin costos agregados
        </p>
      )
    }
  }

  return (
    <>
      <div className='flex flex-col items-center'>
        <div className='flex items-center w-full justify-center'>
          {MODAL_CONTENT[type].icon}
        </div>

        <div className='text-black flex items-center flex-col justify-center text-center mb-9 mt-9 '>
          <h1 className='text-2xl font-bold max-w-[230px]'>
            {MODAL_CONTENT[type].title}
          </h1>
          <span className='text-xs font-medium mt-4'>
            {MODAL_CONTENT[type].content}
          </span>
        </div>
        <PrimaryButton
          buttonText={MODAL_CONTENT[type].buttonText}
          className='mb-8'
          primaryButtonFunction={MODAL_CONTENT[type].action}
        />
        <TextButton
          handleFunction={() => redirectWhatsApp(me?.profile?.name, 'pwd')}
        >
          ¿Necesitás ayuda?
        </TextButton>
      </div>
      <UnavailableCardModal
        setIsOpen={setUnavailableModal}
        isOpen={unavailableModal}
      />
      <MinBalanceModal
        isOpen={balanceModalIsOpen}
        setIsOpen={setBalanceModalIsOpen}
      />
    </>
  )
}

export default AuxModals
